import { useDeviceType } from '@cian/ui-kit/responsive';
import cn from 'classnames';
import React, { PropsWithChildren } from 'react';

import * as styles from './styles.css';

/**
 * Дает тег <section> с дефолтными адаптивными отступами
 * При очень больших экранах, центрует контент
 */

interface ISectionProps {
  testId?: string;
  className?: string;
}
export const Section: React.FC<PropsWithChildren<ISectionProps>> = props => {
  const deviceType = useDeviceType();

  return (
    <section className={cn(styles['section'], styles[deviceType], props.className)} data-testid={props.testId}>
      {props.children}
    </section>
  );
};
